import { InjectionToken } from "@angular/core";

/**
 * @type {InjectionToken<SessionManagerService>} Angular DI provider token for session handler service implementations.
 */
export const SessionManagerServiceToken: InjectionToken<SessionManagerService> = new InjectionToken<SessionManagerService>("core.session-manager.service");

/**
 * The session manager service is the first layer of our client side session handling logic. The session manager's job
 * is to maintain the client side session state. It is called by http interceptors when a back-end response is received,
 * and also updated by components that listen to client side user events to monitor user activity.
 *
 * It is a good practice to initialize this service upon application startup by calling its `init()` method, though if
 * there is a http interceptor that calls the `resetSession()` after a backedn response is active, then the first
 * back-end response will automatically initialize the session manager.
 */
export interface SessionManagerService {
    /**
     * This method initialize the session manager service and resets the session time counter to configured session
     * timeout value.
     */
    init(): void;
    /**
     * This method resets the session time counter to configured session  timeout value.
     */
    resetSession(sessionTime?: number): void;
    /**
     * This method resets the revive timeout counter. It should be used on every user activity. If the revive timeout
     * counter counts down to 0 then the session revive endpoint should be called on the backend. But it is not called
     * by this service.
     */
    resetSessionRevive(): void;
    /**
     * This method collects all the tasks that should be performed on every user activity. Mostly it resets the session
     * revive, but there could be other tasks as well.
     */
    onUserEvent(): void;
    /**
     * This method will initiate all the tasks that should be performed when a fatal error occurs in the application.
     */
    onFatalError(): void;
    /**
     * This method returns true, if session is active.
     */
    isSessionActive(): boolean;
    /**
     * This method set, session timeout warning time.
     */
    setTimeoutWarningTime(sessionTimeOut: number): void;
    /**
     * This method restore session timeouts on page reload on sign and modify page.
     */
    restoreTimeOuts(): void;
}
